import { Icon } from "@iconify/react";
import { Box, Button, Typography } from "@mui/material";
import ToolTip from "../../../../ToolTip/ToolTip";

export const assessmentReportTableHeader = (navigate) => [
  { field: "sl_no", headerName: "Sl No", width: 70 },
  { field: "name", headerName: " Lead Name", width: 250 },
  {
    field: "address",
    headerName: "Place",
    width: 180,
  },
  { field: "leadCameDate", headerName: "Lead Came On", width: 180 },
  // { field: "fatherName", headerName: "Father Name", width: 200 },
  { field: "mob", headerName: "Mobile No", width: 180 },


  {
    field: "isAssessmentTaken",
    headerName: "Assessment Done",
    width: 150,
    renderCell: (params) => {
      if (params.row.isAssessmentTaken == 'YES') {
        return(
          <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
         <Icon icon="healthicons:yes"width="20" height="20"  style={{color: '#45d01b', marginRight: '4px',}} />
          YES
        </Box>
        )
       
      } else if (params.row.isAssessmentTaken == 'NO') {
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Icon icon="healthicons:no" width="20" height="20"  style={{color: '#d01b1b', marginRight: '4px',}} />
            NO
          </Box>
        )
      } else {
        return "UN DEFINED";
      }
    },
  },
  {
    field: "allCourses",
    headerName: "Enrolled Courses",
    width: 300,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.allCourses}
          content={params.row.allCourses}
        />
      );
    },
  },
  {
    field: "combinations",
    headerName: "Suggested Courses",
    width: 300,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.combinations}
          content={params.row.combinations}
        />
      );
    },
  },
  {
    field: "assessmentTakenDate",
    headerName: "Assessment Taken On",
    width: 300,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.assessmentTakenDate}
          content={params.row.assessmentTakenDate}
        />
      );
    },
  },
];
